import sensors from 'sa-sdk-javascript';
import pageleave from 'sa-sdk-javascript/dist/web/plugin/pageleave/index.es6.js';
import { useUserStore } from '@/stores';

// 神策
sensors.use(pageleave, {});
sensors.init({
  server_url: `https://mdgj-sjdr.cast.org.cn/sa?project=${
    location.host.indexOf('m.kepuchina.cn') >= 0 ? 'production' : 'default'
  }`,
  show_log: false,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    collect_tags: {
      div: true,
      span: true,
      img: true,
    },
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
  },
});
sensors.registerPage({
  scene_name: '科普中国Lite',
});
sensors.quick('autoTrack'); //用于采集 $pageview 事件。

export function useShenCe() {
  /**
   * 基本函数
   *
   * @param {string} name
   * @param {*} data
   */
  function track(name: string, data?: object) {
    const userStore = useUserStore();
    const openid = userStore.openid || '';
    try {
      if (name) {
        sensors.track(name, {
          member_id: openid,
          ...data,
        });
      }
    } catch (error) {
      console.log('shence-track', error);
    }
  }

  return {
    track,
  };
}

export default sensors;
